const appKeyLocalStorage = "mfu-er-app";
const currentLocale = "th";
const server_env = "reg.mfu.ac.th";

export default {
  appKeyLocalStorage,
  currentLocale,
  server_env
};
